import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AppShell } from '@/components/shell/AppShell';
import { GameDayProvider } from './providers/GameDayProvider';
import { SidebarProvider } from './providers/SidebarProvider';
import { TabProvider } from './providers/TabProvider';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <GameDayProvider>
              <SidebarProvider>
                <TabProvider>
                  <AppShell />
                </TabProvider>
              </SidebarProvider>
            </GameDayProvider>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
